/* Program Plan lifecycle status — shared across the Planner Tracker suite so every
   screen renders/filters/transitions the same {id, label} enum the API returns on
   a plan (`plan.status`), e.g. {id: 1, label: "Draft"}. */

export const STATUS_META = {
  Draft: { color: '#d97706', progress: 8 },
  'Ready to Launch': { color: '#4f46e5', progress: 12 },
  Launched: { color: '#2563eb', progress: 48 },
  Closed: { color: '#059669', progress: 100 },
  Cancelled: { color: '#dc2626', progress: 0 },
};

/* Maps a tab's status label to the matching key in `GET /plans`'s `tab_counts` object
   (e.g. `{ all, draft, ready_to_launch, launched, closed }` — note it has no `cancelled` key). */
export const STATUS_TAB_COUNT_KEYS = {
  Draft: 'draft',
  'Ready to Launch': 'ready_to_launch',
  Launched: 'launched',
  Closed: 'closed',
  Cancelled: 'cancelled',
};

/* Numeric status ids as defined by the Program Planner API — order matches STATUS_META. */
export const STATUS_IDS = {
  Draft: 1,
  'Ready to Launch': 2,
  Launched: 3,
  Closed: 4,
  Cancelled: 5,
};

/* Status options in the same {id, label} shape the API returns on a plan (`plan.status`) —
   used wherever a status needs to be picked/displayed by id. */
export const STATUS_OPTIONS = Object.entries(STATUS_IDS).map(([label, id]) => ({ id, label }));
